import React from 'react';
import Floater from 'react-floater';
import PropTypes from 'prop-types';
import './ToolTipWrapper.scss';


const propTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  isActive: PropTypes.bool,
  event: PropTypes.string,
  placement: PropTypes.string,
  offset: PropTypes.number,
  delay: PropTypes.number,
};

const defaultProps = {
  isActive: true,
  event: 'hover',
  placement: 'auto',
  offset: 1,
  delay: 0.4,
};

const ToolTipWrapper = ({
  children, content, isActive, event, placement, offset, delay,
}) => {
  if (isActive) {
    return (
      <div className="floater-wrapper">
        <Floater
          offset={offset}
          event={event}
          eventDelay={delay}
          placement={placement}
          content={content}

        >
          {children}
        </Floater>
      </div>

    );
  }
  return (
    <React.Fragment>
      { children }
    </React.Fragment>
  );
};


ToolTipWrapper.propTypes = propTypes;
ToolTipWrapper.defaultProps = defaultProps;


export default ToolTipWrapper;



// WEBPACK FOOTER //
// ./src/components/_molecules/ToolTipWrapper/ToolTipWrapper.js